import { useNavigate } from 'react-router-dom';
import { IconShieldCheck, IconArrowRight } from '@tabler/icons-react';
import { useLogistics } from '../../hooks/useLogistics';

export function InsuranceSummaryCard() {
  const navigate = useNavigate();
  const { logisticsData, isLoading, error } = useLogistics();

  const hasInsurance = !!(logisticsData.insuranceProvider || logisticsData.memberId);

  return (
    <div className="card p-5 h-full">
      <div className="flex items-center gap-2 mb-3">
        <IconShieldCheck size={18} className="text-cyan-400" stroke={1.5} />
        <h3 className="text-sm font-semibold text-gray-100">Insurance</h3>
      </div>

      {isLoading ? (
        <p className="text-xs text-gray-500">Loading...</p>
      ) : error ? (
        <p className="text-xs text-red-400 mb-3">Unable to load insurance info</p>
      ) : hasInsurance ? (
        <>
          {logisticsData.insuranceProvider && (
            <p className="text-sm text-gray-200 font-medium mb-1">{logisticsData.insuranceProvider}</p>
          )}
          {logisticsData.memberId && (
            <p className="text-xs text-gray-500">Member ID: {logisticsData.memberId}</p>
          )}
          {logisticsData.groupNumber && (
            <p className="text-xs text-gray-500">Group: {logisticsData.groupNumber}</p>
          )}
        </>
      ) : (
        <p className="text-xs text-gray-500 mb-3">No insurance information on file</p>
      )}

      <button
        onClick={() => navigate('/insurance')}
        className="flex items-center gap-1 text-xs text-cyan-400 hover:text-cyan-300 transition-colors mt-3"
      >
        View details <IconArrowRight size={12} />
      </button>
    </div>
  );
}
